import GlobalFooter from './global-footer.vue';
export default GlobalFooter;


// WEBPACK FOOTER //
// ./src/components/global-footer/index.js